import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RemoveBankState, removeBankFeatureKey } from '../reducers/remove-bank.reducer';

export const getRemoveBankState = createFeatureSelector<RemoveBankState>(removeBankFeatureKey);
export const getRemoveBankLoading = createSelector(getRemoveBankState, state => state.loading);
export const getRemoveBankResponse = createSelector(getRemoveBankState, state => state.response);
export const getRemoveBankError = createSelector(getRemoveBankState, state => state.error);